import { render } from "./CambiaOfferta.vue?vue&type=template&id=1a804aa3&scoped=true"
import script from "./CambiaOfferta.vue?vue&type=script&lang=js"
export * from "./CambiaOfferta.vue?vue&type=script&lang=js"

import "./CambiaOfferta.vue?vue&type=style&index=0&id=1a804aa3&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a804aa3"]])

export default __exports__